import { IAudioWorkletNode, IMinimalOfflineAudioContext, IOfflineAudioContext } from '../interfaces';
import { TNativeContext } from './native-context';

export type TDeleteUnrenderedAudioWorkletNodeFunction = <T extends IMinimalOfflineAudioContext | IOfflineAudioContext>(
    nativeContext: TNativeContext,
    audioWorkletNode: IAudioWorkletNode<T>
) => void;
